<template class="content">
  <div id="page" class="main-item" v-if="(info || isNew)">
    <div class="black-top">
      <div class="top-menu">
        <div class="right-buttons">
          <div data="status" class="top"></div>
          <div class="published hide"></div>
          <span>{{info._draft?'Draft':'Live'}}</span>
          <Bool class="draft-toggle" v-model="info._draft" />
          <a href="#" @click="publish()" class="button w-button">Publish</a>
        </div>
        <div class="nameback">
          <router-link :to="'/list/'+$route.params.col" class="back w-button">⟨</router-link>
          <h4 class="item-head top">{{isNew?'New Item':info.name}}</h4>
        </div>
        <p class="date">{{info["updated-on"]?$parent.date(info["updated-on"]):''}}</p>
        <!--<p data="date" v-for="fruit in vm.fruits" class="date">{{fruit.name}}</p>-->
      </div>
    </div>
    <div v-if="schema && !loader" id="itempage" class="_700">
      <div
        v-for="(field,i) in schema"
        class="field"
        :key="field.slug"
        v-show="!field.name.match(/^-/)"
      >
        <label v-if="field.slug != 'slug' && field.visible!=false" class="item-label">
          {{field.name}}
          <span
            class="helpText"
            v-tippy
            :title="field.helpText"
            v-if="field.helpText"
          >?</span>
          <span v-tippy title="a Required Field" v-if="field.required" class="req">*</span>
        </label>
        <component
          v-if="field.visible!=false"
          :editable="field.editable"
          @slug="field.slug=='slug'?info.slug=$event:''"
          :is="field.type"
          :slg="field.slug"
          :fname="field.name"
          :validations="field.validations"
          :index="i"
          v-model="info[field.slug]"
        ></component>
      </div>
      <a
        v-if="info._archived"
        @click="publish(info._draft,false)"
        href="#"
        class="button grey w-button"
      >Restore Item</a>
      <a
        v-if="!isNew && !info._archived"
        @click="publish(info._draft,'archive')"
        href="#"
        class="button grey w-button"
      >Archive item</a>
      <a
        v-if="!isNew && info._archived"
        @click="deleteItem()"
        id="delete"
        href="#"
        class="button red w-button"
      >Perminantally delete this item</a>
    </div>

    <loader v-if="loader" zoom="1" />
  </div>
</template>

<script>
import RichText from "@/components/RichText.vue";
import ItemRef from "@/components/ItemRef.vue";
import ItemRefSet from "@/components/ItemRefSet.vue";
import Number from "@/components/Number.vue";
import PlainText from "@/components/PlainText.vue";
import Bool from "@/components/Bool.vue";
import Color from "@/components/Color.vue";
import Video from "@/components/Video.vue";
import Option from "@/components/Option.vue";
import Date from "@/components/Date.vue";
import ImageRef from "@/components/ImageRef.vue";
import Link from "@/components/Link.vue";
import loader from "@/components/loader.vue";
import FileRef from "@/components/FileRef.vue";
import ImageRefSet from "@/components/ImageRefSet.vue";
import Email from "@/components/Email.vue";
import Phone from "@/components/Phone.vue";
import Map from "@/components/Map.vue";

export default {
  name: "home",
  data() {
    return {
      changed: 0,
      schema: [],
      info: {},
      loader: true,
      isNew: false
    };
  },
  methods: {
    publish(draft, archived) {
      this.loader = true;
      $.each(this.schema, (i, e) => {
        if (e.required && e.slug != "slug") {
          if (!this.info[e.slug]) {
            this.$emit("alertMessage", {
              type: "error",
              message: "Please fill out " + e.name + " before publishing"
            });
            this.loader = false;
            return;
          }
        }
      });
      if (this.isNew) {
        this.info._archived = false;
      }
      if (!this.info._draft) this.info._draft = false;

      // if (draft == "draft") {
      //   console.log("this is a draft");
      //   this.info._draft = true;
      // } else {
      //   this.info._draft = false;
      // }
      if (archived) {
        this.info._archived = true;
      } else {
        this.info._archived = false;
      }
      delete this.info._editing;
      if (
        this.schema.find(e => {
          return e.slug == "hiddenslug";
        }) &&
        this.$attrs.collection
      ) {
        this.info.hiddenslug = `https://${this.$parent.activeSite.domain}/${this.$attrs.collection.slug}/`;
      }
      if (wfToken) {
        publish.webflow(
          this.info,
          this.$route.params.col,
          this.$route.params.id,
          this.postPublish
        );
      } else {
        publish.firebase(
          this.info,
          this.$route.params.col,
          this.$route.params.id,
          this.postPublish
        );
      }
    },
    postPublish(inf) {
      this.loader = false;
      this.$emit("alertMessage", {
        type: inf.err ? "error" : "success",
        message: inf.err ? inf.problems[0] : "Published Successfully"
      });
      if (!inf.err) {
        this.info = "";
        this.info = inf;
      }
      if (this.isNew) {
        this.$router.push(`/item/${this.Col}/${inf._id}`);
      }
    },
    deleteCallback(inf) {
      this.loader = false;
      this.$emit("alertMessage", {
        type: inf.err ? "error" : "success",
        message: inf.err ? inf.problems[0] : "Deleted Successfully"
      });
      if (!inf.err) {
        this.$router.push(`/list/${this.Col}`);
      }
    },
    deleteItem() {
      if (
        window.confirm(
          "Are you sure you want to delete " + this.info.name + "?"
        )
      ) {
        this.loader = true;
        if (wfToken) {
          
            // publish.webflow(null,this.$route.params.col,this.$route.params.id,this.deleteCallback);

          deleteItem.webflow(this.Col, this.id, this.deleteCallback);
        } else {
          deleteItem.firebase(this.Col, this.id, this.deleteCallback);
        }
      }
    },
    async getSingleItem(Col, id) {
      // db.doc(`collections/${Col}/items/${id}`).update({
      //   _editing: this.$parent.user.name
      // });
      if (this.$parent.items[this.Col]) {
        this.info = this.$parent.items[this.Col].find(e => {
          return e._id == id;
        });
        this.loader = false;
      } else {
        getdata.singleItem(Col, id, data => {
          this.info = data;
          this.loader = false;
        });
      }
    },
    getItem(Col, id) {
      var itemLink =
        this.$parent.set.preLink +
        "collections/" +
        Col +
        "/items/" +
        id +
        "/?access_token=" +
        this.$parent.set.token +
        "&api_version=1.0.0";
      $.getJSON(itemLink, content => {
        this.info = content.items[0];
        if (this.$parent.items[Col]) {
          this.$parent.items[Col][id] = this.info;
        }
        this.loader = false;
      });
    },
    getSchema(Col) {
      var collection = this.$parent.collections.find(e => {
        return e["_id"] == Col;
      });
      $.each(collection.fields, (i, e) => {
        if (
          !e.slug.match(/^_/) &&
          e.name != "Created On" &&
          e.name != "Updated On" &&
          e.name != "Published On" &&
          e.name != "Created By" &&
          e.name != "Updated By" &&
          e.name != "Published By"
          // && !e.name.match(/^-/)
        ) {
          this.schema.push(e);
          if (e.defaultValue) {
            this.info[e.slug] = e.defaultValue;
          }
          if (this.isNew) {
            this.info[e.slug] = "";
            this.loader = false;
          }
        }
      });
    }
  },
  // watch: {
  //   info: {
  //     deep: true,
  //     handler() {
  //       this.changed++;
  //       var user = this.$parent.user.name;
  //       if (this.changed == 2 && !this.info._editing) {
  //         db.doc(
  //           `collections/${this.$route.params.col}/items/${this.$route.params.id}`
  //         ).update({
  //           _editing: user
  //         });
  //       }
  //     }
  //   }
  // },
  // beforeRouteLeave(to, from, next) {
  //   db.doc(
  //     `collections/${this.$route.params.col}/items/${this.$route.params.id}`
  //   ).update({
  //     _editing: false
  //   });
  //   next();
  // },
  mounted() {
    window.appItem = this;
    //console.log(this.poplink)
    this.Col = this.$route.params.col;
    this.id = this.$route.params.id;
    this.getSchema(this.Col);
    if (this.id != "new-item") {
      this.getSingleItem(this.Col, this.id);
    } else {
      this.isNew = true;
      this.loader = false;
    }
  },
  components: {
    loader,
    FileRef,
    RichText,
    ItemRef,
    ItemRefSet,
    Number,
    PlainText,
    Bool,
    Color,
    Video,
    Option,
    Date,
    ImageRef,
    ImageRefSet,
    Link,
    Email,
    Phone,
    Map
  }
};
</script>

<style scoped>
@media only screen and (max-width: 767px) {
  .main-item {
    margin-top: 0px;
  }
}

.helpText {
  color: #389bff;
  color: white;
  border-radius: 100%;
  padding: 0 4px;
  line-height: 12px;
  text-align: center;
  height: 11px;
  width: 11px;
  margin: 5px;
  font-size: 9px;
  float: right;
  background: #1f2228;
  background-color: #389bff;
}
.button.grey {
  display: block;
  background: darkgrey;
  max-width: 235px;
  color: black;
}
#page {
  padding-bottom: 160px;
}
.red {
  margin-top: 40px;
}
</style>


